import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
// Serialization
import { deserialize } from 'serializr';
import { invoiceSchema } from './schemas';
// Fragments
import { invoiceFragment } from './fragments';
// Custom
import { SEARCHFIELD_TYPES } from '../../constants/App';

// Permissions used in model

/**
 * Serialization
 */
const deserializeInvoice = (data) => deserialize(invoiceSchema, data);

/**
 * GraphQL
 */
const queListCarparkInvoices = `
  query ListCarparkInvoices($input: ListCarparkInvoicesInput!, $pagination: PaginationInput, $search: ListCarparkInvoicesSearchInput, $sort: [ListCarparkInvoicesSortInput]) {
    listCarparkInvoices(input: $input, pagination: $pagination, search: $search, sort: $sort) {
      entries {
        ...invoiceFragment
      },
      pageNumber,
      pageSize,
      totalEntries,
      totalPages
    }
  }

  ${invoiceFragment}
`;

const mutDownloadCarparkInvoice = `
  mutation DownloadCarparkInvoice($input: DownloadCarparkInvoiceInput!) {
    downloadCarparkInvoice(input: $input) {
      uri
    }
  }
`;

const mutDownloadCarparkInvoices = `
  mutation DownloadCarparkInvoices($input: DownloadCarparkInvoicesInput!, $search:ListCarparkInvoicesSearchInput) {
    downloadCarparkInvoices(input: $input, search: $search) {
      uri
    }
  }
`;

const mutDownloadMyBookingInvoice = `
  mutation DownloadMyInvoice($input: DownloadMyInvoiceInput!) {
    downloadMyInvoice(input: $input) {
      uri
    }
  }
`;

const mutUpdateCarparkInvoice = `
  mutation UpdateCarparkInvoice($input: UpdateCarparkInvoiceInput!) {
    updateCarparkInvoice(input: $input) {
      number
    }
  }
`;

/**
 * Model
 */
const invoice = {
  name: 'invoice',
  icon: 'invoice',

  // Serialization
  deserialize: deserializeInvoice,

  // List Bookings features
  listFeatures: {
    // Default list params
    defaultParams: {
      pagination: {
        page: 1,
        pageSize: 20,
      },
      sort: [{ field: 'date', dir: 'desc' }],
    },

    // Columns
    columnsQuantity: () => ({
      xs: 2,
      sm: 2,
      md: 4,
      lg: 8,
      xl: 8,
    }),
    columns: [
      {
        key: 'number',
        labelId: 'field.number',
        field: 'number',
        sortable: false,
      },
      {
        key: 'date',
        labelId: 'field.date',
        field: 'date',
        sortable: true,
      },
      {
        key: 'customerLastname',
        labelId: 'field.lastname',
        field: 'customerLastname',
        sortable: true,
        className: 'hidden-sm-down',
      },
      {
        key: 'customerEmail',
        labelId: 'field.email',
        field: 'customerEmail',
        sortable: false,
        className: 'hidden-sm-down',
      },
      {
        key: 'amountExclTax',
        labelId: 'field.amountExclTax',
        sortable: false,
        field: 'amountExclTax',
        className: 'table-content-2 table-content-center hidden-md-down',
      },
      {
        key: 'taxAmount',
        labelId: 'field.taxAmount',
        sortable: false,
        field: 'taxAmount',
        className: 'table-content-2 table-content-center hidden-md-down',
      },
      {
        key: 'amountInclTax',
        labelId: 'field.amountInclTax',
        sortable: false,
        field: 'amountInclTax',
        className: 'table-content-2 table-content-center hidden-md-down',
      },
      {
        key: 'serviceFeeAmountInclTax',
        labelId: 'field.serviceFeeAmountInclTax',
        sortable: false,
        field: 'serviceFeeAmountInclTax',
        className: 'table-content-2 table-content-center hidden-md-down',
      },
    ],

    // Search fields
    searchFields: [
      {
        key: 'number',
        labelId: 'field.number',
        field: 'number',
        initial: '',
        isUndefined: (value) => _isEmpty(value),
        needGetOnInit: false,
        type: SEARCHFIELD_TYPES.string,
        filter: {
          field: 'number',
        },
      },
      {
        key: 'after',
        labelId: 'field.afterDate',
        field: 'after',
        initial: null,
        isUndefined: (value) => _isNil(value),
        needGetOnInit: false,
        type: SEARCHFIELD_TYPES.date,
        scope: 'after',
        filter: {
          field: 'date',
        },
      },
      {
        key: 'before',
        labelId: 'field.beforeDate',
        field: 'before',
        initial: null,
        isUndefined: (value) => _isNil(value),
        needGetOnInit: false,
        type: SEARCHFIELD_TYPES.date,
        scope: 'before',
        filter: {
          field: 'date',
        },
      },
      {
        key: 'customerLastname',
        labelId: 'field.lastname',
        field: 'customerLastname',
        initial: '',
        isUndefined: (value) => _isEmpty(value),
        needGetOnInit: false,
        type: SEARCHFIELD_TYPES.string,
        filter: {
          field: 'customerLastname',
        },
      },
      {
        key: 'customerEmail',
        labelId: 'field.email',
        field: 'customerEmail',
        initial: '',
        isUndefined: (value) => _isEmpty(value),
        needGetOnInit: false,
        type: SEARCHFIELD_TYPES.string,
        filter: {
          field: 'customerEmail',
        },
      },
      {
        key: 'licensePlate',
        labelId: 'field.licensePlate',
        field: 'licensePlate',
        initial: '',
        isUndefined: (value) => _isEmpty(value),
        needGetOnInit: false,
        type: SEARCHFIELD_TYPES.string,
        withOperators: true,
        filter: {
          field: 'licensePlate',
        },
      },
      {
        key: 'reference',
        labelId: 'field.reference',
        field: 'reference',
        initial: '',
        isUndefined: (value) => _isEmpty(value),
        needGetOnInit: false,
        type: SEARCHFIELD_TYPES.string,
        withOperators: true,
        filter: {
          field: 'reference',
        },
      },
    ],
  },

  // GraphQL
  queListCarparkInvoices,
  mutDownloadCarparkInvoice,
  mutDownloadCarparkInvoices,
  mutDownloadMyBookingInvoice,
  mutUpdateCarparkInvoice,
};

module.exports = invoice;



// WEBPACK FOOTER //
// ./models/cpm/invoice.js